import css from "./login.module.css"
import Button from "@mui/material/Button"
import companyLogo from "@assets/images/S&P_Global_logo.svg"
import { isLoggedIn } from "@store/authAtoms"
import { useSearchParams } from "react-router"
import { buildTargetParams, checkSetPassOnParams } from "@store/services/authQuery"
function Login() {
  const [searchParams] = useSearchParams()
  const target = searchParams.get("target")
  const targeted = buildTargetParams(target || window.location.href)
  const app_name = import.meta.env.VITE_PRODUCT_NAME

  if (isLoggedIn()) {
    // force it to show login, JWT is expired
    const redirect = target ? target : "/"
    window.location.assign(redirect)
  } else {
    checkSetPassOnParams()
  }

  return (
    <div className={css.loginContainer}>
      <img className="companyLogo" src={companyLogo} alt="S&P Global" />
      <p>Welcome to {app_name}</p>
      <Button
        sx={{ width: 200, marginBottom: "1em" }}
        variant="contained"
        onClick={() => window.location.assign(import.meta.env.VITE_AUTH_LOGIN_URL + targeted)}
      >
        Login
      </Button>
      <div>
        <a
          className={css.privacyPolicyLink}
          href="https://www.spglobal.com/en/privacy/privacy-policy-english"
          target="_blank"
          rel="noopener noreferrer"
        >
          Privacy Policy
        </a>{" "}
        &{" "}
        <a
          className={css.privacyPolicyLink}
          href="https://www.spglobal.com/content/dam/spglobal/corporate/en/privacy/Corporate_Privacy_Policy_Review_Jan_2026.pdf"
          target="_blank"
          rel="noopener noreferrer"
        >
          Corporate Privacy Policy
        </a>
      </div>
    </div>
  )
}

export default Login
